import isYesterday from 'date-fns/isYesterday';
import { isMoreThanOneWeekAgo } from '../../common/utils/date';
import { selectUnit } from '../../common/utils/dateUtils';
import { timeMessages } from './messages';
var formatTime = function formatTime(timeStamp, intl) {
  var isAbsolute = isMoreThanOneWeekAgo(timeStamp);
  if (isAbsolute) {
    return intl.formatDate(timeStamp, {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }
  var _selectUnit = selectUnit(timeStamp, new Date(), {
      day: 7 // treat a week as 7 days (default is 5)
    }),
    value = _selectUnit.value,
    unit = _selectUnit.unit;
  //formats as 'yesterday' instead of '1 day ago'
  if (isYesterday(timeStamp)) {
    return intl.formatRelativeTime(value, unit, {
      numeric: 'auto'
    });
  }
  return intl.formatRelativeTime(value, unit);
};
var renderAbsoluteOrRelativeDate = function renderAbsoluteOrRelativeDate(timeStamp, pageAction, intl) {
  return intl.formatMessage(timeMessages[pageAction], {
    time: formatTime(timeStamp, intl)
  });
};
export var transformTimeStamp = function transformTimeStamp(intl, lastViewedDate, lastUpdatedDate) {
  if (lastViewedDate) {
    return renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
  }
  if (lastUpdatedDate) {
    return renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
  }
};